import { type CampaignSource } from '../../../../../types/campaign.types';

/**
 * Default campaign status.
 * For campaigns that are using single startDate/endDate range (no interval slots).
 * End date is the reliable source of truth.
 */

export const evaluateDefaultCampaignStatus = (campaign: CampaignSource) => {
  const startDate = campaign?.startDate ? new Date(campaign.startDate) : null;
  const endDate = campaign?.endDate ? new Date(campaign.endDate) : null;
  const now = new Date();

  const isFinished = !!endDate && now > endDate;
  const isActive = !isFinished && !!startDate && !!endDate && now >= startDate && now <= endDate;
  const isPromo = !isFinished && !!startDate && now < startDate;

  return { isActive, isFinished, isPromo };
};
